var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.className,attrs:{"to":"/","exact":""}},[_c('BaseImage',{staticClass:"header-navbar__logo",attrs:{"src":_vm.logoImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }